import _ from 'lodash';
import {
  useCallback,
  useEffect,
  useState
} from 'react';
import {
  useNavigate,
  useSearchParams
} from 'react-router-dom';

import { ChevronRight } from '@mui/icons-material';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListSubheader,
  TextField
} from '@mui/material';

import { useInfiniteScroll } from 'modules/common/layer00';
import * as ds from './dataService';



export type StockTickerListProps = {
  selectedCompanyId?: string;
  onClick?: (companyId: string) => void;
};

export const FC = (props: StockTickerListProps) => {
  const [params] = useSearchParams();

  const [
    ticker,
    setTicker
  ] = useState('');
  const { data, fetchMore } = ds.useQuery({
    ticker,
    limit: 30,
    offset: 0
  });

  const navigate = useNavigate();

  const handleLoadMore = useCallback(
    () => {
      fetchMore({
        variables: {
          options: {
            paginationInput: {
              limit: 20,
              offset: data.tickers.length
            },
            filter: {
              ticker,
              timeFrame: 'oneYear'
            }
          }
        },
        updateQuery: (prevQuery, { fetchMoreResult }) => {
          const companies = _.concat(...prevQuery.listedCompanies, fetchMoreResult.listedCompanies);

          return {
            ...prevQuery,
            listedCompanies: _.unionBy(companies, (node) => node.id)
          };
        }
      });
    }, [
      data.tickers.length,
      fetchMore,
      ticker
    ]
  );


  useEffect(() => {
    if (data.tickers.length > 10 && data.tickers.length <= 100) {
      return handleLoadMore();
    }
    return () => { };
  }, [
    data.tickers.length,
    handleLoadMore
  ]);



  const observerTargetRef = useInfiniteScroll({
    onBecameVisible: () => {
      if (data.tickers.length >= 50) {
        console.log('Getting data');
        handleLoadMore();
      } else {
        console.log('Not fetching');
      }
    }
  });



  return (
    <List
      sx={{
        borderRadius: (theme) => theme.shape.borderRadius,
        background: 'white',
        paddingTop: 0,
        overflow: 'auto',
        maxHeight: '100%',
        '& ul': {
          padding: 0
        }
      }}
      subheader={<li />}
    >
      <li>
        <ul>
          <ListSubheader sx={{
            paddingTop: 2,
            background: 'white'
          }}
          >
            <ListItemText sx={{
              mt: 0
            }}
            >
              Symbol
            </ListItemText>

            <TextField
              size='small'
              placeholder='Search'
              value={ticker}
              onChange={(ev) => {
                setTicker(ev.target.value);
              }}
            />
          </ListSubheader>

          {data.tickers.map((ticker, i) => (
            <ListItem
              ref={i === data.tickers.length - 10 ? observerTargetRef : null}
              key={ticker.id}
              dense
            >
              <ListItemButton
                selected={props.selectedCompanyId === ticker.id}
                onClick={() => {
                  if (props.onClick) {
                    props.onClick(ticker.id);
                  } else {
                    const index = params.get('n');
                    if (index) {
                      navigate(`/company/${ticker.id}?n=${index}`, {
                        replace: true
                      });
                    } else {
                      navigate(`/company/${ticker.id}`, {
                        replace: true
                      });
                    }
                  }
                }}
              >
                {ticker.id === props.selectedCompanyId && (
                  <ChevronRight sx={{
                    color: 'white'
                  }}
                  />
                )}

                <ListItemText
                  sx={{
                    marginLeft: '.5rem'
                  }}
                >
                  {ticker.ticker}
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </ul>
      </li>
    </List>
  );
};
